/**
 * Created by Ning Jiang on 2022-05-03.
 */

import {WinPresentationController} from "../WinPresentationController";
import {Serial} from "../../Serial";
import {RevealedSymbol} from "../../symbol/RevealedSymbol";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {SerialSound} from "../../sound/SerialSound";

export class XWaysRevealController extends WinPresentationController {

    private _revealName:string;

    constructor() {
        super("XWaysRevealController", false);
    }

    protected hasWin():boolean {
        this._revealName = Serial.model.parsedGameData.mysterySymbolReveal;
        return this._revealName != null && this._revealName.length > 0 && !Serial.model.parsedGameData.nextMode.includes("RESPIN");
    }

    protected async createWinAnimation():Promise<any> {
        const promises:Promise<any>[] = [];
        let playSound:boolean = false;
        Serial.model.parsedGameData.xWaysDataList.forEach((xWaysData) => {
            const position = xWaysData.symbolPosition.concat();
            const reveal = new RevealedSymbol(this._revealName, position[0], Serial.getReelView(position[0], position[1]).getSymbolHeight(), xWaysData.numberOfWays);
            const oldSymbol = (position[1] > 1 && position[1] < 5) ? Serial.reels[position[0]].replaceSymbol(reveal, position[1] - 2) : Serial.enhancerReels[position[0]][position[1]].replaceSymbol(reveal);
            // if(oldSymbol.symbolName != "X") {
            //     debugger;
            //     throw new Error(`XWaysRevealController, reel${reelId} symbol${symId} is not xWays symbol.`);
            // }
            oldSymbol.onRemove();
            Serial.ways.updateWays(position[0], position[1], xWaysData.numberOfWays);

            const ani = new TimelineSprite(Serial.assetLoader.getTextures('xways/reveal/reveal_'), 50);
            ani.anchor.set(0.5);
            promises.push(Promise.resolve(reveal.playReveal(ani)));
            playSound = true;
        });

        if(playSound) {
            SerialSound.soundPlayer.playTrack({name : SerialSound.XWAYS_REVEAL});
        }

        await Promise.all(promises);
    }
}